import { useEffect } from "react";

const DEFAULT_IGNORE_SELECTORS = [".ls-prime-toast", ".p-toast"];

const normalizeRefs = (refs) => {
  if (!refs) return [];
  return Array.isArray(refs) ? refs : [refs];
};

const resolveElement = (ref) => {
  if (!ref) return null;
  const current = ref.current ?? ref;
  if (!current) return null;
  if (typeof current.contains === "function") return current;
  if (typeof current.getElement === "function") return current.getElement();
  if (current.container && typeof current.container.contains === "function") {
    return current.container;
  }
  return null;
};

const useDropdownClose = (isOpen, onClose, refs, options = {}) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const refList = normalizeRefs(refs);

    const handleClickOutside = (event) => {
      if (options.shouldIgnore && options.shouldIgnore(event)) {
        return;
      }
      const selectors = [
        ...DEFAULT_IGNORE_SELECTORS,
        ...(Array.isArray(options.ignoreSelectors)
          ? options.ignoreSelectors
          : options.ignoreSelectors
            ? [options.ignoreSelectors]
            : []),
      ];
      if (
        event?.target instanceof Element &&
        selectors.some((selector) => event.target.closest(selector))
      ) {
          return;
      }
      const clickedInside = refList.some(
        (ref) => {
          const el = resolveElement(ref);
          return el ? el.contains(event.target) : false;
        }
      );
      if (!clickedInside) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose, refs]);
};

export default useDropdownClose;
